import { render, staticRenderFns } from "./InfoCuponAmigoActivado.vue?vue&type=template&id=5aca81e2&"
import script from "./InfoCuponAmigoActivado.vue?vue&type=script&lang=js&"
export * from "./InfoCuponAmigoActivado.vue?vue&type=script&lang=js&"
import style0 from "./InfoCuponAmigoActivado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports